// ponytail: vue-json-pretty cria um nó DOM por chave, payload grande trava a aba.
// O corte é no stringify, então a árvore nem chega a ser montada.
export const MAX_RENDER_CHARS = 100000

export default function jsonPreview(data) {
  const json = JSON.stringify(data, null, 2) || ''
  const kb = json.length / 1024

  return {
    json,
    size: kb < 1024 ? `${Math.round(kb)} KB` : `${(kb / 1024).toFixed(1)} MB`,
    tooLarge: json.length > MAX_RENDER_CHARS
  }
}
